export default __webpack_public_path__ + "static/media/weprofile-192x192.ee9dc495.png";